module["exports"] = [
  "gmail.com",
  "yahoo.fr",
  "hotmail.fr"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/internet/free_email.js
// module id = 723
// module chunks = 0